import { render, staticRenderFns } from "./noScoreDetails.vue?vue&type=template&id=812bcc48&scoped=true&"
import script from "./noScoreDetails.vue?vue&type=script&lang=js&"
export * from "./noScoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./noScoreDetails.vue?vue&type=style&index=0&id=812bcc48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812bcc48",
  null
  
)

export default component.exports